module.exports = __webpack_public_path__ + "media/images/sp/brands/common/logo_eight-053d013abfbc0200fd6a472b22b86674.svg";